import * as React from 'react';

export const Loading = () => {
  return <div className="h-screen flex flex-col justify-center items-center"><h2 className="block">loading</h2></div>;
};
